import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface NavigationBarProps {
  onNavigate?: (path: string) => void;
}

export function NavigationBar({ onNavigate }: NavigationBarProps) {
  const location = useLocation();
  const currentPath = location.pathname;
  const isProjects = currentPath === '/projects' || currentPath.startsWith('/projects/');
  const { t } = useTranslation();

  // Handle navigation with either the provided callback or default Link behavior
  const handleNavClick = (path: string, e: React.MouseEvent) => {
    if (onNavigate) {
      e.preventDefault();
      onNavigate(path);
    }
  };

  return (
    <nav className="bottom-nav">
      <Link 
        to="/"
        onClick={(e) => handleNavClick('/', e)}
        className={`nav-button ${currentPath === '/' ? 'active' : ''}`}
      >
        <span className="material-symbols-outlined">home</span>
        <span className="nav-label">{t('navigation.home')}</span>
      </Link>
      <Link
        to="/projects"
        onClick={(e) => handleNavClick('/projects', e)}
        className={`nav-button ${isProjects ? 'active' : ''}`}
      >
        <span className="material-symbols-outlined">folder</span>
        <span className="nav-label">{t('navigation.projects')}</span>
      </Link>
      <Link 
        to="/profile"
        onClick={(e) => handleNavClick('/profile', e)}
        className={`nav-button ${currentPath === '/profile' ? 'active' : ''}`}
      >
        <span className="material-symbols-outlined">person</span>
        <span className="nav-label">{t('navigation.profile')}</span>
      </Link>
    </nav>
  );
} 